import { render, staticRenderFns } from "./NewCard.vue?vue&type=template&id=a49bee92&scoped=true"
import script from "./NewCard.vue?vue&type=script&lang=js"
export * from "./NewCard.vue?vue&type=script&lang=js"
import style0 from "./NewCard.vue?vue&type=style&index=0&id=a49bee92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a49bee92",
  null
  
)

export default component.exports